module.exports = __webpack_public_path__ + "img/icone_fluxo_reverso_vermelho.32fe8698.png";